const initialState = {
    statusShow: false,
    loaderStatus: false,
    fullname:'',
};
const modalFinalizeRegistration = (state = initialState, action) => {
    switch (action.type) {
        case 'OPEN_MODAL_FINALIZE_REGISTRATION':
            return {...state, statusShow: true};
        case 'CLOSE_MODAL_FINALIZE_REGISTRATION':
            return {...state, statusShow: false};
            case 'CHANGE_INPUTS_FINALIZE_REGISTRATION':
            return {...state, [action.name]: action.value};
        default:
            return state;
    }
};

export default modalFinalizeRegistration;